import "./confirm-message-modal.cmponent.scss";

import { memo } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmMessageModal1Id } from "../../hooks/useBlocker";

const ConfirmMessageModal = ({
  domId = ConfirmMessageModal1Id,
  firstMessage = '4e2dca38c3',
  secondMessage = 'e3a825c094',
  leftButtonTitle = 'bafd7322c6',
  rightButtonTitle = '93cba07454',
  confirmLeving = () => { } }
) => {
  const { t } = useTranslation();

  return (
    <>
      <div id={domId} className="confirm-message-modal-overlay" hidden>
        <div className="confirm-message-modal">
          <div className="message-box">
            {firstMessage && <span>{t(firstMessage)}</span>}
            {secondMessage && <span>{t(secondMessage)}</span>}
          </div>
          <div className="btn-group">
            <button
              className="b b-cancel"
              onClick={() => confirmLeving(false)}
            >
              {t(leftButtonTitle)}
            </button>
            <button
              className="b b-confirmation"
              onClick={() => confirmLeving(true)}
            >
              {t(rightButtonTitle)}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(ConfirmMessageModal);